module.exports = __webpack_public_path__ + "img/denied-verify.c93233e5.svg";